var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DF1E",
    fillRule: "evenodd",
    d: "M6 6h500v500H6V6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M137.468 423.836l38.264-23.156c7.382 13.088 14.097 24.162 30.204 24.162 15.439 0 25.174-6.04 25.174-29.532V235.548h46.987v160.427c0 48.666-28.527 70.818-70.147 70.818-37.588 0-59.407-19.468-70.482-42.961M303.619 418.801l38.259-22.151c10.071 16.448 23.161 28.529 46.318 28.529 19.469 0 31.884-9.734 31.884-23.159 0-16.111-12.753-21.817-34.234-31.211l-11.744-5.038c-33.9-14.43-56.388-32.554-56.388-70.816 0-35.242 26.85-62.093 68.805-62.093 29.872 0 51.352 10.405 66.789 37.592l-36.584 23.493c-8.056-14.431-16.779-20.136-30.204-20.136-13.761 0-22.488 8.726-22.488 20.136 0 14.097 8.727 19.804 28.863 28.531l11.746 5.034c39.94 17.118 62.428 34.569 62.428 73.836 0 42.292-33.227 65.449-77.865 65.449-43.632 0-71.825-20.808-85.584-47.996",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.6b5f74c3c37d85d9050823052671f1f1.svg";
export { ForwardRef as ReactComponent };